// extracted by mini-css-extract-plugin
export var container = "_c1-0";